"use client";

import { Check } from "lucide-react";

type ModuleSectionProps = {
  title: string;
  description: string;
  bullets: string[];
  visual: React.ReactNode;
  reversed?: boolean;
  accentColor?: string;
};

export function ModuleSection({
  title,
  description,
  bullets,
  visual,
  reversed = false,
  accentColor = "bg-keiront-green",
}: ModuleSectionProps) {
  const textContent = (
    <div className={`flex flex-col justify-center ${reversed ? "lg:order-2" : ""}`}>
      <div className={`border-l-4 pl-6 ${accentColor.replace("bg-", "border-")}`}>
        <h3 className="text-3xl font-bold text-slate-900 mb-4">{title}</h3>
        <p className="text-lg text-slate-600 mb-8 leading-relaxed">{description}</p>
      </div>

      <ul className="space-y-3">
        {bullets.map((bullet, idx) => (
          <li key={idx} className="flex items-start gap-3">
            <Check className="w-5 h-5 text-keiront-green flex-shrink-0 mt-0.5" />
            <span className="text-slate-700">{bullet}</span>
          </li>
        ))}
      </ul>
    </div>
  );

  const visualContent = (
    <div className={`flex items-center justify-center ${reversed ? "lg:order-1" : ""}`}>
      <div className="w-full rounded-xl border border-slate-200 bg-slate-50 aspect-[4/3] flex items-center justify-center overflow-hidden">
        {visual}
      </div>
    </div>
  );

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {reversed ? (
            <>
              {visualContent}
              {textContent}
            </>
          ) : (
            <>
              {textContent}
              {visualContent}
            </>
          )}
        </div>
      </div>
    </section>
  );
}
